import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { InviteSuccessPage } from "@/features/invitee/success";

export const Route = createFileRoute(
  "/(member)/(public)/invite/$token/success",
)({
  component: InviteSuccessPage,
  validateSearch: z.object({
    placeId: z.string().optional(),
  }),
  head: () => ({
    meta: [
      { title: "Birdwatch - Welcome" },
      {
        name: "description",
        content: "Your Birdwatch household invitation was accepted",
      },
    ],
  }),
});
